import { Loadmore, Toast, Badge, Popup } from 'mint-ui';
import { dataHandle } from '../../../services/data-handle.js';
import bus from '../../eventBus';
import { emoji } from '../emoji/emoji.js'
let lastLabel = [];
export default {
    components: {
        'mt-loadmore': Loadmore
    },
    props: {
        chatList: Array,
        cid: String,
        queue: [String, Number],
        businessType: [String, Number]
    },
    data() {
        return {
            historyStatus: '',
            topStatus: '',
            audioIndex: -1,    // 当前播放的语音的索引
            isSend: this.queue,
            emojiNameExp: null,
            videoSrc: '',
            popupVisible: false,
            answerHtml: '',
            contextmenu: {
                show: false,
                left: 0,
                top: 0,
                currMsgInfo: null,
                copyText: ''
            }
        }
    },
    watch: {
        'queue'(value) {
            this.isSend = value;
        },
        'contextmenu.show'(value) {
          if (value) {
                document.body.addEventListener('click', this.closeContextmenu)
          } else {
                document.body.removeEventListener('click', this.closeContextmenu)
          }
        }
    },
    mounted() {
        this.dataHandle = dataHandle;
        this.emojiNameExp = new RegExp('(' + Object.keys(emoji).map(key=>"\\[" + key + '\\]').join('|') + ')', 'g');
    },
    methods: {
        /**
         * 格式化时间
         * @param { Number|String } date  => 时间
         * @returns
         */
        formatDate(date) {
            return dataHandle.formatDate(date);
        },
        /**
         * 是否显示时间 (前后信息相隔2分钟)
         * @param { Number } index => 当前信息的index
         * @returns
         */
        showTimes(index) {
            if(!index||(dataHandle.getDateTimes(this.chatList[index].date) && dataHandle.getDateTimes(this.chatList[index-1].date) && dataHandle.getDateTimes(this.chatList[index].date)-dataHandle.getDateTimes(this.chatList[index-1].date)>=120000)) {
                return true;
            }
            return false;
        },
        /**
         * 处理html对话内容
         *
         * @param { String } content  => 对话内容
         * @returns
         */
        handleHtml(content, item) {
            if (item && item.sender == 'bot') {
                if (this.checkSensitive(item, 1)) {
                    content += '<p class="enter-link">👉<a href="javascript:;" name="customer">人工客服</a></p>';
                }else if (this.checkSensitive(item, 2)) {
                    content += '<p class="enter-link">👉<a href="javascript:;" name="feedback">立即反馈</a></p>';
                }
            }
            content = this.character2Html(content);
            if (item && item.sender == 'user' && item.extend && item.extend.docLabels && item.extend.docLabels.length > 0) {
                let str = '';
                for (var i = 0; i < item.extend.docLabels.length; i++) {
                    str += '@' + item.extend.docLabels[i] + ' ';
                }
                let some = this.filterArrSome(item.extend.docLabels, lastLabel);
                if (!some) {
                    content = str + content;
                    lastLabel = [...item.extend.docLabels];
                }
            }
            return content;
        },
        /**
         * 比较两数组是否一样
         * */
        filterArrSome(arr1, arr2){
            if (arr1 === arr2) {
                return true;
            }
            if (arr1 === null || arr2 === null) {
                return false;
            }
            if (arr1.length != arr2.length) {
                return false;
            }
            return !arr1.some((item, index)=> item !== arr2[index]);
        },
        /**
        * 特殊字符转换
        * */
        character2Html(content){
            if (/\[.+\]/.test(content)) {
                return content.replace(this.emojiNameExp, v=>{
                    let str = v.replace('[', '').replace(']', '');
                    let o_emoji = emoji[str];
                    if (o_emoji) {
                        let img_html = '<img src="' + require('@/assets/icon/emoji/' + o_emoji.icon) + '" data-code="' + str + '" class="chat-emoji-icon" >';
                        return img_html;
                    }
                    return v;
                });
            }
            return content;
        },
        async loadDialog() {
            if(this.historyStatus == 'finished') return;
            this.$refs.loadmore.onTopLoaded();
            let times = dataHandle.getDateTimes(this.chatList[0].date);
            let res = await this.$parent.getChatHistory(times);
            if(res) {
                this.topStatus = res;
                this.historyStatus = res;
            }
        },
        handleTopChange(status) {
            if(this.historyStatus == 'finished') {
                this.topStatus = 'finished';
                return;
            }
            this.topStatus = status;
        },
        /**
         * 点击问题列表提问
         * @param { String } content 提问内容
         */
        sendListMsg(content) {
            if (this.isSend == 1) {
                return;
            }
            bus.$emit('send', {
                type: 'text',
                content: content
            });
        },
        /**
         * 获取聊天素材
         * @param { String } fileId   素材id
         * @param { Number } sender   1=>user  2=>bot
         * @param { String } kind     类型
         * @param { String } id       类型为图片时的refp
         * @returns
         */
        getImg(fileId, sender, kind, id) {
            let type = sender == 'bot' ? 2 : 1;
            let pic = `${window.fileApi}/file/${type}/${fileId}`;
            if(kind == 'image') {
                let newImg = new Image()
                newImg.src = pic;
                newImg.onerror = () => { // 图片加载错误时的替换图片
                    newImg.src = require('../../../assets/icon/error.svg');
                    this.$refs[id][0].src = newImg.src;
                    this.$previewRefresh();  // vue-photo-preview
                }
                newImg.onload = () => { // 图片加载成功后把地址给原来的img
                    this.$refs[id][0].src = newImg.src;
                    this.$refs[id][0].style = 'width:auto;height: auto; min-width: 100px;min-height: 100px;max-width: 70%;';
                    this.$previewRefresh();  // vue-photo-preview
                }
            }else if (kind == 'reduceImg') {
                return pic + '?process=image/resize,m_fixed,h_100,w_100';
            }else if(kind == 'reduceVideo'){
                return pic + '?process=video/snapshot,t_1000,f_jpg,w_100,h_100';
            } else {
                return pic;
            }
        },
        /**
         * 打开文件
         * */
        openFile(item){
            let file = `${window.fileApi}/file/1/${item.media.mediaId}?fileName=${item.media.fileName}`;
            location.href = file;
        },
        /**
         * 播放语音
         * @param { Number } index
         */
        play(index) {
            if(this.audioIndex == index) {
                this.audioIndex = -1;
                this.$refs['audio_'+index][0].pause();
                this.$refs['audio_'+index][0].load();
            }else {
                this.audioIndex = index;
                this.$refs['audio_'+index][0].play();
            }
            this.$refs['audio_'+index][0].addEventListener("pause", ()=> {
                this.audioIndex = -1;
                this.$refs['audio_'+index][0].pause();
                this.$refs['audio_'+index][0].load();
            });
        },
        checkSensitive(item, type){
          if (this.cid && !!item.cid) {
            if (type == 1) {
                let menuList = [];
                if (sessionStorage.getItem('menuList')) {
                    menuList = JSON.parse(sessionStorage.getItem('menuList'));
                }
                let isShow = false;
                if (menuList.length > 0) {
                    for (var i = 0; i < menuList.length; i++) {
                        if (menuList[i].code == 'artificial' && menuList[i].isShow) {
                            isShow = true;
                            break;
                        }
                    }
                }
                return (this.cid == item.cid && item.extra && item.extra.hasOp && isShow) ? true : false;
            }else{
                return (this.cid == item.cid && item.extra && item.extra.hasFeedback) ? true : false;
            }
            }else{
                return false;
            }
        },
        async goArtificial(){
            this.$parent.transferCustomer();
        },
        enterLink(item, event){
            if (event.target.name === 'customer') {
                // 人工客服
                this.goArtificial();
            }else if(event.target.name === 'feedback'){
                // 反馈
                this.$parent.toFeedback(item.extra.hitType);
            }
        },
        waitingHtml(content){
            if (content.endsWith('</p>')) {
                return content.slice(0,-4) + '<a class="primary" name="cancelWaiting">【取消排队】</a></p>';
            }
            return content + '<a class="primary" name="cancelWaiting">【取消排队】</a>';
        },
        /**
         * 取消人工客服排队
         * */
        cancalWaiting(event){
            if (event.target.name === 'cancelWaiting') {
                this.$emit('cancelTransferCustomer');
            }
        },
        /**
         * 评价
         * @param { Object } item 
         * @param { Number } index     索引值
         */
        giveStar(item,index) {
            // console.log(index);
            if (item.manual.level) {
                Toast('您已对当前服务进行过评价');
                return;
            }
            if (Date.now() - new Date(item.date).getTime() > 30*60*1000) {
                Toast('已超过评价时间');
                return;
            }
            this.$set(item.manual.starInfo,"defaultStar", index);
            this.$set(item.manual,"labels", []);
        },
        /**
         * 满意度标签
         * */
        selectLabel(item,tag){
            if (item.manual.level) {
                Toast('您已对当前服务进行过评价');
                return;
            }
            if (Date.now() - new Date(item.date).getTime() > 30*60*1000) {
                Toast('已超过评价时间');
                return;
            }
            if (item.manual.labels.indexOf(tag) > -1) {
                item.manual.labels.splice(item.manual.labels.indexOf(tag), 1);
            }else{
                if (item.manual.starInfo.maxLabelCount == item.manual.labels.length) {
                    this.$set(item.manual,"disabled", true);
                    let that = this;
                    setTimeout(function(){
                        that.$set(item.manual,"disabled", false);
                    }, 4000)
                    return;
                }
                item.manual.labels.push(tag);
            }
        },
        readonlyContent(item){
            if (item.manual.level) {
                return true;
            }
            return false;
        },
        /**
         * 提交评价
         * */
        sendSatisfaction(item){
            if (item.manual.level) {
                Toast('您已对当前服务进行过评价');
                return;
            }
            if (item.manual.starInfo.defaultStar == 0) {
                return;
            }
            if (Date.now() - new Date(item.date).getTime() > 30*60*1000) {
                Toast('已超过评价时间');
                return;
            }
            this.$set(item.manual,"level", item.manual.starInfo.defaultStar);
            this.$emit('sendSatisfaction', item.manual.sessionKey, item.manual.starInfo.defaultStar, item.manual.labels, item.manual.content);
        },
        /**
         * 播放视频
         * */
        payVideo(item){
            this.$set(item, 'play', true);
            this.$nextTick(()=>{
                this.$refs['video_' + item.msgId][0].play();
            })
        },
        /**
         * 查看回复来源
         * */
        openPopupToAnswer(contentHtml, index){
            this.closeContextmenu();
            this.answerHtml = '<span class="mint-badge is-primary is-size-small">' + (index + 1) +'</span>' + contentHtml;
            this.popupVisible = true;
        },
        // 打开右键菜单
        openContextmenu(e,item) {
            if (e.target.clientWidth !=0 && e.clientX > (e.target.clientWidth-20)) {
                this.contextmenu.left = e.target.clientWidth - 20;
            }else{
                this.contextmenu.left = e.clientX;
            }
            this.contextmenu.top = e.clientY;
            this.contextmenu.currMsgInfo = item;
            this.contextmenu.copyText = item.content;
            this.contextmenu.show = true;
        },
        // 关闭右键菜单
        closeContextmenu() {
            this.contextmenu.currMsgInfo = null;
            this.contextmenu.show = false;
        },
        /**
         * 菜单项响应事件
         * */
        contextmenuOp(type){
            if (type === 'copy') {
                var text = this.contextmenu.copyText;
                this.$copyText(text);
            }else{
                this.$emit('sendRateCompletion', type, this.contextmenu.currMsgInfo.msgId);
            }
            this.closeContextmenu();
        },
        isShowMenu(){
            if (this.contextmenu.currMsgInfo.extend.like || this.contextmenu.currMsgInfo.extend.like == 0) {
                return false;
            }else{
                return true;
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/webot/dialog/_dialog.js